require("moment/locale/de");

let messagesPromise;

if (process.env.NODE_ENV === "production") {
    messagesPromise = import(/* webpackChunkName: "de-generated", webpackMode: "eager" */ "@/i18n/translations/de.generated.js").then(
        generatedLanguageModule => {
            return generatedLanguageModule.default;
        }
    );
} else {
    messagesPromise = import(/* webpackChunkName: "language-development", webpackMode: "eager" */ "@/i18n/language.development").then(
        generatorModule => {
            return generatorModule.generate("de");
        }
    );
}

export default messagesPromise;
